import {t} from './index';
// Complete phrases avoid passing English noun suffixes or verbs into other languages.
export const messageStatusLabel = (key, count) => t(`common:${key}_${Number(count) === 1 ? 'one' : 'other'}`, {count});
export const moreAlertsLabel = count => t(`messages:moreAlert_${Number(count) === 1 ? 'one' : 'other'}`, {count});
export const formatSubscriptionPeriod = (unit, count) => {
    const normalized = String(unit || '').toLowerCase();
    const supported = ['day', 'week', 'month', 'year'].includes(normalized) ? normalized : 'period';
    return t(`billing:period_${supported}_${Number(count) === 1 ? 'one' : 'other'}`, {count});
};
